import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Section from '../../common/section';

const useStyles = makeStyles({
  root: {
    padding: '2.4375rem 2.6875rem',
  },
  overview: {
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    whiteSpace: 'pre-wrap'
  },
});

const View = ({ overview }) => {
  const classes = useStyles();
  if (!overview) return null;

  return (
    <Section title="Overview">
      <Paper className={classes.root}>
        <Typography className={classes.overview} variant="body1">
          {overview}
        </Typography>
      </Paper>
    </Section>
  );
};

View.propTypes = {
  overview: PropTypes.string.isRequired,
};

export default View;
